import { FC, ReactNode, useEffect, useRef, useState } from 'react'
import cn from 'classnames'
import { useMutableRef } from '@/hooks/useMutableRef'
import styles from './VisibilityHandler.module.scss'

type VisibilityHandlerProps = {
  className?: string
  once?: boolean
  children?: ReactNode
  onVisible: (payload?: string) => void
  payload?: string
}

export const VisibilityHandler: FC<VisibilityHandlerProps> = (props) => {
  const { children, className, onVisible, once, payload } = props
  const [isFirst, setIsFirst] = useState(true)

  const containerRef = useRef<HTMLDivElement>(null)
  const onVisibleRef = useMutableRef(onVisible)

  useEffect(() => {
    const { current } = containerRef

    if (!current || (once && !isFirst)) return

    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      if (entries.length === 0 || !entries[0].isIntersecting) return

      if (!once || isFirst) {
        onVisibleRef.current(payload)
      }

      if (isFirst) {
        setIsFirst(false)
      }
    }

    const observer = new IntersectionObserver(handleIntersection)
    observer.observe(current)
    handleIntersection(observer.takeRecords())

    return () => {
      observer.disconnect()
    }
  }, [isFirst, payload, onVisibleRef, once])

  return (
    <div className={cn(styles.container, className)} ref={containerRef}>
      {children}
    </div>
  )
}
